module.exports = __webpack_public_path__ + "static/img/user-logo.b10ea19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my/user-logo.png
// module id = 88LW
// module chunks = 208